import VendedorEmailService from "@/services/VendedorEmailService";

export const vendedorEmail = {
  namespaced: true,
  state: {
    vendedorEmail: {},
  },
  actions: {
    getVendedorEmail({ commit }, payload) {
      return VendedorEmailService.GetVendedorEmail(payload).then(
        (vendedorEmail) => {
          return Promise.resolve(vendedorEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postVendedorEmail({ commit }, payload) {
      return VendedorEmailService.PostVendedorEmail(payload).then(
        (vendedorEmail) => {
          return Promise.resolve(vendedorEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putVendedorEmail({ commit }, payload) {
      return VendedorEmailService.PutVendedorEmail(payload).then(
        (vendedorEmail) => {
          return Promise.resolve(vendedorEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteVendedorEmail({ commit }, payload) {
      return VendedorEmailService.DeleteVendedorEmail(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getVendedorEmailOData({ commit }, payload) {
      return VendedorEmailService.GetVendedorEmailOData(payload).then(
        (vendedorEmail) => {
          return Promise.resolve(vendedorEmail);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default vendedorEmail;
